import React, { useEffect, useRef, useState } from 'react';
import ballImageSrc from './img/bekel.png'; // Adjust the path to your image file
import paddleImageSrc from './img/tatakann.png'; // Adjust the path to your paddle image file
import bounceball from './music/bounce.mp3';

const Canvas = ({ gameState }) => {
    const canvasRef = useRef(null);
    const ballImageRef = useRef(new Image());
    const paddleImageRef = useRef(new Image());
    const [rotationAngle, setRotationAngle] = useState(0);

    // Preload the ball and paddle images
    useEffect(() => {
        ballImageRef.current.src = ballImageSrc;
        paddleImageRef.current.src = paddleImageSrc;
    }, []);

    // Update the rotation angle over time
    useEffect(() => {
        const interval = setInterval(() => {
            setRotationAngle(prevAngle => (prevAngle + 0.01) % (2 * Math.PI)); // Adjust the speed of rotation by changing 0.01
        }, 16); // approximately 60 FPS

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
    
        const { ball, paddle } = gameState;
    
        // Set the paddle dimensions directly here
        const paddleWidth = 180; // Adjust width
        const paddleHeight = 30; // Adjust height

        // Set the ball radius
        const ballRadius = 50; // Adjust the radius as needed
    
        // Clear the canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    
        // Save the context state
        ctx.save();
    
        // Move the context to the ball's center
        ctx.translate(ball.x, ball.y);
    
        // Rotate the context
        ctx.rotate(rotationAngle);
    
        // Draw the ball using the preloaded image
        ctx.drawImage(ballImageRef.current, -ballRadius, -ballRadius, ballRadius * 2, ballRadius * 2);
    
        // Restore the context state
        ctx.restore();
    
        // Draw the paddle if it is visible
        if (paddle.isVisible) {
            ctx.drawImage(paddleImageRef.current, paddle.x, canvas.height - paddleHeight, paddleWidth, paddleHeight);
        }
    }, [gameState, rotationAngle]);

    return (
        <canvas
            ref={canvasRef}
            id="myCanvas"
            width="200"
            height="600"
            className='lg:mb-28 lg:w-48 sm:w-24 md:w-78'
        />

    );
};

export default Canvas;
